import { render, staticRenderFns } from "./VaccineHistoryAssesment.vue?vue&type=template&id=b283209e&scoped=true"
import script from "./VaccineHistoryAssesment.vue?vue&type=script&lang=js"
export * from "./VaccineHistoryAssesment.vue?vue&type=script&lang=js"
import style0 from "./VaccineHistoryAssesment.vue?vue&type=style&index=0&id=b283209e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b283209e",
  null
  
)

export default component.exports